export const initialState = {
    id: '',
    name: '',
    surname: '',
    email: '',
    password: '',
};
